module.exports = __webpack_public_path__ + "media/images/emblems/Vernate-coat_of_arms-1cbd2ba8121452148ff2febb8b0f9b46.svg";